import React from 'react';

import {GlobalExternalLinkEnum, ProductEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import {StyledLink} from './styles';

const {appointmentCard} = translations['pt-br'].privateFlow.myAppointments;

export function AppointmentTeleTutorial() {
	const {
		dataHostNameState: {product},
	} = useHostName();

	const telehealthTutorial = {
		[ProductEnum.HAP]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_HAP,
		[ProductEnum.CCG]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_CCG,
		[ProductEnum.CLINIPAM]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_CLINIPAM,
		[ProductEnum.GNDI_MINAS]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_GNDI_MINAS,
		[ProductEnum.GNDI]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_GNDI_SP,
		[ProductEnum.NOTREDAME_SAUDE]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_GNDI_SP,
	};

	const handleWatchTutorial = () => {
		window.open(telehealthTutorial[product]);
	};

	return (
		<StyledLink onClick={handleWatchTutorial}>
			{appointmentCard.teleHealth.linkTutorial}
		</StyledLink>
	);
}
